import { toast } from "react-toastify";

interface ICopyToClipboardArgs {
  text: string;
  successMessage?: string;
  errorMessage?: string;
}

export const copyToClipboardText = async ({
  text,
  successMessage = "Success to copy!",
  errorMessage = "Failed to copy!",
}: ICopyToClipboardArgs): Promise<string> => {
  try {
    await navigator.clipboard.writeText(text);

    toast.success(successMessage);
    return "success";
  } catch {
    toast.error(errorMessage);
    return "error";
  }
};
